import { render, staticRenderFns } from "./InvestmentSecondaryMarket.vue?vue&type=template&id=637aefb6&scoped=true&"
import script from "./InvestmentSecondaryMarket.vue?vue&type=script&lang=js&"
export * from "./InvestmentSecondaryMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637aefb6",
  null
  
)

export default component.exports